import lodashUniqueBy from "lodash/uniqBy";
import { getPropertyValue } from "~/cores/appCore";
import _ from "lodash";
import { variantHasInventory } from "~/cores/exchangeToProductsCore";
import lodashIsNil from "lodash/isNil";
import { getProductProperties } from "~/cores/productCore";

const SIZES = [
    "XXXXS",
    "4XS",
    "XXXS",
    "3XS",
    "XXS",
    "XXS-SHORT",
    "XXS-LONG",
    "2XS",
    "XS",
    "XS-SHORT",
    "XS-REGULAR",
    "XS-LONG",
    "S",
    "S-SHORT",
    "S-REGULAR",
    "S-LONG",
    "SMALL",
    "M",
    "M-SHORT",
    "M-REGULAR",
    "M-LONG",
    "MEDIUM",
    "L",
    "L-SHORT",
    "L-REGULAR",
    "L-LONG",
    "LARGE",
    "XL",
    "XL-SHORT",
    "XL-REGULAR",
    "XL-LONG",
    "XXL",
    "XXL-SHORT",
    "XXL-REGULAR",
    "XXL-LONG",
    "2XL",
    "XXXL",
    "3XL",
    "XXXXL",
    "4XL",
];

const COLOR = "Color";
const SIZE = "Size";
const UNKNOWN = "UNKNOWN";

function parsePropertyType(propertyType) {
    let t = propertyType?.toLowerCase();
    if (t === "color" || t === "colour") {
        return COLOR;
    } else if (t === "size") {
        return SIZE;
    } else {
        return UNKNOWN;
    }
}

export function getPropertyTypeTitle({ appProps, propertyType }) {
    const { getLocaleText } = appProps;
    return getLocaleText("variant." + parsePropertyType(propertyType));
}

export function isPropertyEnabled({ exchangeAlternatives, propertyType, propertyTypeChoices, propertyValue }) {
    return !!exchangeAlternatives
        ?.filter((alternative) => variantHasInventory(alternative))
        ?.find((alternative) => {
            const properties = exchangeAlternatives[0]?.properties;
            return properties.every((property, i) => {
                const selectedValue = propertyTypeChoices[property.type];
                if (alternative?.properties?.[i]?.type === propertyType) {
                    return alternative?.properties?.[i]?.value === propertyValue;
                } else {
                    return lodashIsNil(selectedValue) || selectedValue === alternative?.properties?.[i]?.value;
                }
            });
        });
}

export function compareSize(p1, p2) {
    const p1Value = p1?.value;
    const p2Value = p2?.value;

    const v1 = _.isNumber(p1Value) ? "" + p1Value : p1Value;
    const v2 = _.isNumber(p2Value) ? "" + p2Value : p2Value;
    let i1 = SIZES.indexOf(v1?.toUpperCase());
    let i2 = SIZES.indexOf(v2?.toUpperCase());
    // if (i1 === -1 || i2 === -1) {
    //     return 0;
    // }
    if (i1 > -1 && i2 > -1) {
        return i1 - i2;
    }
    // if (!isNaN(v1) && !isNaN(v2)) {
    //     return Number(1) - Number(s2);
    // } else {
    if (v1 < v2) {
        return -1;
    } else if (v1 > v2) {
        return 1;
    }
    return 0;
    // }
}

export function parsePropertyMap(exchangeAlternatives, product) {
    let result = {};
    exchangeAlternatives?.forEach((alternative) => {
        alternative?.properties.forEach(({ type, value, ...rest }) => {
            const valueObject = {
                value,
                type,
                ...rest,
            };
            result[type] = (result[type] || []).concat(valueObject);
        });
    });

    Object.keys(result).forEach((k) => {
        result[k] = lodashUniqueBy(result[k], "value");
        // if (parsePropertyType(k) === SIZE) {
        result[k].sort(compareSize);
        // }
        if (result[k].length === 1 && result[k][0]?.value === getPropertyValue({ product, propertyType: k })) {
            // remove alternative if it's only the original products property available
            delete result[k];
        }
    });
    return result;
}

export function translatePropertyValue({ appProps, productExchangeServiceData, propertyType, propertyValue }) {
    const { language } = appProps;
    const propertyTranslations = productExchangeServiceData?.data?.propertyTranslations;

    return propertyTranslations?.[propertyType]?.[propertyValue]?.[language] || propertyValue;
}

export function getPropertyName(property) {
    return property?.name;
}

export function isPropertyEqualToReturningVariant(property, { selectedProperties, selectedProduct }) {
    const selectedProductProperties = _.clone(getProductProperties(selectedProduct));
    const selectedPropertiesClone = _.clone(selectedProperties);
    selectedPropertiesClone[property?.type] = property?.value;

    const doesNotMatch = selectedProductProperties?.some(({ type, value }) => {
        return selectedPropertiesClone[type] !== value;
    });
    return !doesNotMatch;
}
